import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import ListingDetails from './ListingDetails';
import Link from '../../Link';

// Locale
import messages from '../../../locale/jsonMessages';

//Style
import cs from '../../../components/commonStyle.css';
import s from './Rating.css';

class RatingConfirmation extends React.Component {

  static propTypes = {
    data: PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      reviewsCount: PropTypes.number.isRequired,
      street: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired,
      coverPhoto: PropTypes.number,
      reviewsCount: PropTypes.number,
      reviewsStarRating: PropTypes.number,
      listPhotos: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
      }))
    }),
    formatMessage: PropTypes.any,
  };

  render() {
    const { data, hostData, dynamicListTitle, listTitle } = this.props;

    return (
      <div>
        <Row className={s.landingContainer}>
          <Col xs={12} sm={6} md={6} lg={6} className={cx(s.spaceTop5)}>
            <h3 className={cx(s.textBold, s.landingContentTitle)}><FormattedMessage {...messages.reviewTitle} /></h3>
            <p className={cx(s.reviewEndText, cs.spaceBottom2)}>
              <FormattedMessage {...messages.reviewTitle2} />
            </p>
            <div className={cx(cs.displayFlex, cs.justifyContentFlexEnd, cs.spaceBottom5)}>
              <Link
                className={cs.btnPrimary}
                to={"/user/reviews/about-you"}
              >
                <FormattedMessage {...messages.finish} />
              </Link>
            </div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={12} className={cx(s.spaceTop5)}>
            <ListingDetails data={data} hostData={hostData} listTitle={listTitle} />
          </Col>
        </Row>
      </div>
    );
  }
}


export default injectIntl(withStyles(cs, s)(RatingConfirmation));
